import React from "react";
import './Loading.css';
import { CircularProgress } from '@mui/material';

function Loading({ color }) {
    return (
        <div className="loading-container">
            <CircularProgress color={color || "primary"} />
        </div>
    )
}

export default Loading;